module.exports = __webpack_public_path__ + "static/media/40-9.8f47941f.mp3";